import type { HTMLAttributes, Ref } from 'react'
import { cn } from '@/shared/lib'

// ref — deep-link на карточку: страница прокручивает список к нужной.
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
  accent?: boolean
  interactive?: boolean
}

export function Card({
  accent = false,
  interactive = false,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        'rounded-card bg-bg-surface px-6 py-5',
        accent && 'ring-1 ring-border-accent ring-inset',
        interactive && 'transition-colors hover:bg-bg-raised',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
